import { type ReactElement } from 'react';
import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { TableCell, TableRow } from '@avanta/shared/components/ui/Table';

interface TableSkeletonProps {
  columnWidths?: string[];
  columns?: number;
  rows?: number;
  keyPrefix?: string;
}

export const TableSkeleton = ({
  columnWidths,
  columns,
  rows = 4,
  keyPrefix = 'table-skeleton',
}: TableSkeletonProps): ReactElement => {
  // If columns is provided, create uniform widths; otherwise use columnWidths
  const widths = columns
    ? Array.from({ length: columns }, () => `w-1/${columns}`)
    : (columnWidths ?? []);

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={`${keyPrefix}-row-${rowIndex}`}>
          {widths.map((width, colIndex) => (
            <TableCell key={`${keyPrefix}-cell-${rowIndex}-${colIndex}`}>
              <Skeleton className={`h-4 ${width}`} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
